import React, { useState, useRef } from 'react';
import InputMask from 'react-input-mask';

const FloatingLabelInput = ({ label, mask, value, onChange, type = "text", readOnly = false }) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  const setInputRef = (element) => {
    inputRef.current = element;
  };

  const wrapperClasses = "relative w-full";

  const inputClasses = `w-full py-3.5 px-4 rounded-xl border-2 text-base text-gray-800 outline-none transition-all duration-200 ${
    isFocused
      ? 'border-[#147F26] bg-white shadow-lg shadow-[#147F26]/10'
      : 'border-gray-200 bg-gray-50 hover:border-gray-300'
  } ${readOnly ? 'cursor-not-allowed bg-gray-100' : ''}`;

  const inputProps = {
    value: value || '',
    onChange,
    type,
    className: inputClasses,
    onFocus: handleFocus,
    onBlur: handleBlur,
    readOnly,
  };

  return (
    <div className={wrapperClasses}>
      {label && (
        <label
          htmlFor={label}
          className={`block text-sm font-medium mb-2 ${isFocused || value ? 'text-[#147F26]' : 'text-gray-500'}`}
        >
          {label}
        </label>
      )}
      {mask ? (
        <InputMask
          mask={mask}
          {...inputProps}
          inputRef={setInputRef}
        />
      ) : (
        <input
          {...inputProps}
          ref={inputRef}
        />
      )}
    </div>
  );
};

export default FloatingLabelInput;
